import { render, staticRenderFns } from "./Common-SideBarItem.vue?vue&type=template&id=e8c0bd98&"
import script from "./Common-SideBarItem.vue?vue&type=script&lang=js&"
export * from "./Common-SideBarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports